import request from '@/utils/request'


export function getPageList(data) {
  return request({
    url: 'musclePatch/getPageList',
    method: 'post',
    data
  })
}

export function save(data) {
  return request({
    url: 'musclePatch/save',
    method: 'post',
    data
  })
}

export function del(data) {
    return request({
      url: 'musclePatch/delete',
      method: 'post',
      data
    })
  }
